import HttpUtil from '@/utils/service/http';

export default class Base extends HttpUtil {
    /**
     * 业务层很方便的发 get 请求
     * @param  {String} path    [description] 请求路径
     * @param  {String} token   [description] 请求token
     * @param  {Object} payload [description] 请求路径
     * @return {Object}         [description] 响应结果
     */
    static async doGet(path: any, token: any, payload: any) {
        return await this.get(path, { token, ...payload });
    }

    /**
     * 业务层很方便的发 post 请求
     * @param  {String} path    [description] 请求路径
     * @param  {String} token   [description] 请求token
     * @param  {Object} payload [description] 请求路径
     * @return {Object}         [description] 响应结果
     */
    static async doPost(path: any, token: any, payload: any) {
        return await this.post(path, { token, ...payload });
    }
}
